import React from "react";
import { forwardRef } from "@chakra-ui/react";

import { Box } from "Shared";

// Used to wrap child views that don't make sense at full width
export const ContainerNarrow = forwardRef((props, ref) => (
  <Box maxWidth="60rem" mx="auto" ref={ref} {...props} />
));
